























































































































































































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import DiscordProfileBadge from '~/components/Discord/DiscordProfileBadge.vue';
import AuthQuery from '~/mixins/AuthQuery';
import { IDiscordProfile, IUser } from '~/store/profile/types';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import * as ConnectedAccountHelpers from '../../helpers/connected-account-helpers';
import { IConnectedAccount } from '../../types/gala-store';
import { default as SteamLinkedAccount } from './LinkedAccounts/Steam.vue';
import Web3WalletConnections from './Web3WalletConnections.vue';
import SocialLogins from './LinkedAccounts/SocialLogins.vue';

@Component({
  components: {
    DiscordProfileBadge,
    SteamLinkedAccount,
    TwoFactorAuthInputPrompt,
    Web3WalletConnections,
    SocialLogins,
  },
})
export default class LinkedAccounts extends Mixins(AuthQuery) {
  @State(
    profile => {
      return profile.user.discordProfile;
    },
    { namespace: 'profile' },
  )
  readonly discordProfile?: IDiscordProfile;

  @Mutation('updateUser', { namespace: 'profile' })
  private updateUser!: (user: Partial<IUser>) => void;

  get discordConnected() {
    return !!this.discordProfile;
  }

  discordLogo = require('@/assets/logos/discord-empty-profile.png');
  epicGamesLogo = require('@/assets/logos/epic-games.png');

  @State(
    profile => {
      return (profile.user?.connectedAccounts || []).find(
        (connectedAccount: IConnectedAccount) =>
          connectedAccount.connectionName === 'epic_games',
      );
    },
    { namespace: 'profile' },
  )
  epicGamesProfile?: IConnectedAccount;

  @Mutation toggleDiscordDialog!: (args: any) => void;

  private epicConnectionUri = process.env.epicStoreAccountLinkUrl;
  private showEpicGamesLinkedAccount = process.env.showEpicGamesLinkedAccount;
  private state: ConnectedAccountHelpers.ConnectedAccountState = {
    state: 'unknown',
  };

  async toggleEpic() {
    if (Boolean(this.epicGamesProfile)) {
      await this.disconnectAccount('epic_games');
      return;
    }

    this.connectAccount({
      connectionName: 'epic_games',
      initiateConnection: true,
    });
  }

  connectAccount(args: {
    exchangeCode?: string | undefined;
    connectionName: ConnectedAccountHelpers.ConnectionName;
    initiateConnection: boolean;
  }) {
    const connectionUri =
      args.connectionName === 'epic_games'
        ? ConnectedAccountHelpers.getConnectionUri(
            this.epicConnectionUri,
            `${this.$route.fullPath.replace(
              /&?component=LinkedAccounts/,
              '',
            )}component=LinkedAccounts&linking-identity=${args.connectionName}`,
          )
        : '';
    ConnectedAccountHelpers.connectAccount(
      {
        apolloClient: this.$apolloProvider.clients.defaultClient,
        setState: state => {
          this.state = state;
        },
        handleUnauthenticated: () => {
          throw new Error(
            'Unexpected state: Unauthenticated user viewing LinkedAccountsSettings',
          );
        },
        connectionUri,
        refreshUser: () => {
          this.$store.dispatch('profile/refreshUser');
        },
      },
      {
        exchangeCode: args?.exchangeCode,
        connectionUrl:
          args.connectionName === 'epic_games' ? this.epicConnectionUri : '',
        connectionName: args?.connectionName,
        initiateConnection: args.initiateConnection,
        requiresEmailVerification: false,
      },
    );
  }

  async disconnectAccount(
    connectionName: ConnectedAccountHelpers.ConnectionName,
  ) {
    return await this.doAuthQuery(async totpToken => {
      await ConnectedAccountHelpers.disconnectAccount(
        {
          apolloClient: this.$apolloProvider.clients.defaultClient,
          setState: state => {
            this.state = state;
          },
          refreshUser: () => {
            this.$store.dispatch('profile/refreshUser');
          },
        },
        {
          connectionName,
          totpToken,
        },
      );
    }, TwoFaCheckpoint.accountModifications);
  }

  get exchangeCode() {
    return typeof this.$route.query.code === 'string' &&
      this.$route.query.code.length > 0
      ? this.$route.query.code
      : undefined;
  }

  get connectionName() {
    return typeof this.$route.query.name === 'string' &&
      this.$route.query.name.length > 0
      ? this.$route.query.name
      : this.$route.query['linking-identity'];
  }

  created() {
    this.connectAccount({
      connectionName: (this.connectionName ||
        'epic_games') as ConnectedAccountHelpers.ConnectionName,
      exchangeCode: this.exchangeCode,
      initiateConnection: false,
    });
  }
}
